// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDek_root__R8OvU","feature":"ArticleDek_feature__m3Nep","twoCol":"ArticleDek_twoCol__wvFaq"};